// Import of creatApp from Vue 3 bundler.
import { createApp } from 'vue/dist/vue.esm-bundler.js';

// App imports.
import storiesApp from './vue/stories.js';
import activitiesApp from './vue/activities.js';
import organizationsApp from './vue/organizations.js';
import themesApp from './vue/themes.js';
import regionsApp from './vue/regions.js';
import periodsApp from './vue/periods.js';
import relatedContentApp from './vue/relatedContent.js';

document.addEventListener('DOMContentLoaded', () => {
    // Mounting containers listing and DOM targeting.
    const verhaalOverviewContainer = document.getElementById('verhaal-overview');
    const activiteitOverviewContainer = document.getElementById('activiteit-overview');
    const organisatieOverviewContainer = document.getElementById('organisatie-overview');
    const themaOverviewContainer = document.getElementById('thema-overview');
    const regioOverviewContainer = document.getElementById('regio-overview');
    const tijdvakOverviewContainer = document.getElementById('tijdvak-overview');

    const verhalenWidgetContainers = document.querySelectorAll('.widget-verhalen');
    const activiteitenWidgetContainers = document.querySelectorAll('.widget-activiteiten');
    const relatedContentWidgetContainers = document.querySelectorAll('.widget-related-content');

    // For each app, only build the Vue instance if the targeted element is present and mount the app on the targeted element.
    if (verhaalOverviewContainer) {
        createApp(storiesApp).mount(verhaalOverviewContainer);
    }

    if (activiteitOverviewContainer) {
        createApp(activitiesApp).mount(activiteitOverviewContainer);
    }

    if (organisatieOverviewContainer) {
        createApp(organizationsApp).mount(organisatieOverviewContainer);
    }

    if (themaOverviewContainer) {
        createApp(themesApp).mount(themaOverviewContainer);
    }

    if (regioOverviewContainer) {
        createApp(regionsApp).mount(regioOverviewContainer);
    }

    if (tijdvakOverviewContainer) {
        createApp(periodsApp).mount(tijdvakOverviewContainer);
    }

    if (verhalenWidgetContainers.length) {
        verhalenWidgetContainers.forEach(container => {
            createApp(storiesApp).mount(container);
        });
    }

    if (activiteitenWidgetContainers.length) {
        activiteitenWidgetContainers.forEach(container => {
            createApp(activitiesApp).mount(container);
        });
    }

    if (relatedContentWidgetContainers.length) {
        relatedContentWidgetContainers.forEach(container => {
            createApp(relatedContentApp).mount(container);
        });
    }
});
